import axios from "axios";
import { useEffect, useState } from "react";
import IniciaRow from "./iniciaRow";
import { webApiColecciones } from ".././../../routes/endpoints";
import { coleccionesDTO } from "../../../models/Colecciones.model";
import Loading from "../../../utilities/Loading";

export default function Recuadros(){
    const [colecciones, setColecciones] = useState<coleccionesDTO[]>([]);
    useEffect(()=>{
        axios.get(webApiColecciones).then((response) => {
            setColecciones(response.data)                                       
        }).catch(err => console.warn(err));         
    },[]);       
      
    const getColumna = (columna:number ) =>  colecciones?.filter( (col) => columna === col.columna && col.padre === null );
    let c = 0;    
    if(colecciones.length){
        return(  
            <>        
                { 
                    colecciones?.map( (coleccion, i) =>                
                        {  
                            if(coleccion.columna !== c){  
                                c = coleccion.columna                                                                              
                                return <IniciaRow key={i} element={i} titulo={coleccion.titulo} id={coleccion.id} colec={getColumna(coleccion.columna)} data={colecciones} />
                            }            
                        }             
                    )
                }
            </>
        )
    }else{
        return(
            <div className="container-fluid "> 
                <Loading/>
            </div>
        )        
    }
}